import React, { FC, useRef } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link } from "@material-ui/core";
import { TEXTS } from "../../constants";

const NoAccessModal: FC = () => {
  const ref = useRef(null);

  const handleClick = () => window.history.back();

  return (
    <div>
      <Dialog open>
        <DialogTitle>{TEXTS.TITLE}</DialogTitle>
        <DialogContent ref={ref}>
          <DialogContentText>Your subscription does not have access to {TEXTS.TITLE}.</DialogContentText>
          <DialogContentText>
            Find out more about IPD&apos;s complete offerings, and request a demo by visiting your{" "}
            <Link href="https://userprofile.ipdanalytics.com" target="_blank">
              Subscription &amp; Profile Info page,
            </Link>{" "}
            or by contacting <Link href="mailto:healthcare@ipdanalytics.com">healthcare@ipdanalytics.com</Link>.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClick()}>Back</Button>
          <Link href="https://userprofile.ipdanalytics.com" target="_blank" color="primary" underline="none">
            <Button>Learn More</Button>
          </Link>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default NoAccessModal;
